<app-stat-lesson-desc
  [lesson]="lesson"
  [show_second_row]='false'>
</app-stat-lesson-desc>
<div class="text-center student_info-title">{{pupil.surname}} {{pupil.name}}</div>
<app-stat-lesson-desc
  *ngIf='individual_data && lesson'
  [lesson]="lesson"
  [avg_amount_speed]="avg_amount_speed"
  [avg_resolve_speed]="avg_resolve_speed"
  [extra_exercise]="individual_data?.lesson_extra_exercise"
  [currency]="currency"
>
</app-stat-lesson-desc>
